function initCustomerPrivacy () {
    if (!window.Shopify.customerPrivacy) {
        window.Shopify.loadFeatures(
            [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
            ],
            function(error) {
                if (error) {
                    console.error('Privacy API load error:', error);
                    throw error;
                }
                console.log('Privacy API load success:', window.Shopify.customerPrivacy);

                // Set initial checkbox states based on current consent status
                document.getElementById('privacy_personalization').checked = window.Shopify.customerPrivacy.preferencesProcessingAllowed();
                document.getElementById('privacy_marketing').checked = window.Shopify.customerPrivacy.marketingAllowed();
                document.getElementById('privacy_analytics').checked = window.Shopify.customerPrivacy.analyticsProcessingAllowed();    
            }
        );
    } else {
        // Set initial checkbox states based on current consent status
        document.getElementById('privacy_personalization').checked = window.Shopify.customerPrivacy.preferencesProcessingAllowed();
        document.getElementById('privacy_marketing').checked = window.Shopify.customerPrivacy.marketingAllowed();
        document.getElementById('privacy_analytics').checked = window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    }
};

function updateCustomerPrivacy () {
    if (!window.Shopify.customerPrivacy) {
        window.Shopify.loadFeatures(
            [
            {
                name: 'consent-tracking-api',
                version: '0.1',
            },
            ],
            function(error) {
                if (error) {
                    console.error('Privacy API load error:', error);
                    throw error;
                }
                console.log('Privacy API load success:', window.Shopify.customerPrivacy);
                const analyticsCheckboxVal = document.getElementById('privacy_analytics').checked ? true : false;
                const marketingCheckboxVal = document.getElementById('privacy_marketing').checked ? true : false; // marketing and sale_of_data use same id
                const preferencesCheckboxVal = document.getElementById('privacy_personalization').checked ? true : false;

                window.Shopify.customerPrivacy.setTrackingConsent(
                    {
                        analytics: analyticsCheckboxVal,
                        marketing: marketingCheckboxVal,
                        preferences: preferencesCheckboxVal,
                        sale_of_data: marketingCheckboxVal
                    },
                    function() {
                        console.log('Cookie consent status updated.');
                        document.getElementById('customer-privacy-success-message').classList.remove('hidden');
                        document.getElementById('customer-privacy-form').classList.add('hidden');
                    }
                );    
            }
        );
    } else {
        const analyticsCheckboxVal = document.getElementById('privacy_analytics').checked ? true : false;
        const marketingCheckboxVal = document.getElementById('privacy_marketing').checked ? true : false; // marketing and sale_of_data use same id
        const preferencesCheckboxVal = document.getElementById('privacy_personalization').checked ? true : false;

        window.Shopify.customerPrivacy.setTrackingConsent(
            {
                analytics: analyticsCheckboxVal,
                marketing: marketingCheckboxVal,
                preferences: preferencesCheckboxVal,
                sale_of_data: marketingCheckboxVal
            },
            function() {
                console.log('Cookie consent status updated.');
                document.getElementById('customer-privacy-success-message').classList.remove('hidden');
                document.getElementById('customer-privacy-form').classList.add('hidden');
            }
        );
    }
}